import axios from "./index";

class ProductPlannerApi {
  static listProducts = () => {
    return axios.get(`/product-planner`);
  };

  static showProduct = (id) => {
    return axios.get(`/product-planner/${id}`);
  };

  static createProduct = (data) => {
    return axios.post(`/product-planner`, data);
  };

  static updateProduct = (id, data) => {
    return axios.put(`/product-planner/${id}`, data);
  };

  static deleteProduct = (id) => {
    return axios.delete(`/product-planner/${id}`);
  };

  static deactivatePlanner = () => {
    return axios.delete(`/product-planner/deactivate`);
  };

  static optimizePurchases = (budget, max_items) => {
    return axios.get(`/product-planner/optimize-purchases`, {
      params: { budget, max_items },
    });
  };
}

export default ProductPlannerApi;
